
(function(template){
    define('vue!app/views/vue/basicComponents/radioButton',['Vue', 'vuex'],function(Vue, vuex){
        return {
            template:template,
            props: ['options','selected', 'disabled','ariaLabel'],
            methods: {
                handleRadioClick: function(val){
                    if(this.disabled) return;

                    this.$emit('update:selected',val)
                    this.$emit('setActiveServ',val)
                },
                handleSelect: function(val){
                    this.$emit('update:selected',val.target.value)
                    this.$emit('setActiveServ',val.target.value)
                }
            }
        }
    })
})('<div class="radioButtonContainer"> <div class="filter-item" @click="handleRadioClick(filter.val)" v-for="(filter,index) in options" :key="index"> <input type="radio" role="radio" :aria-label="ariaLabel" :tabindex="(selected==filter.val && !disabled) ? 0 : -1" :aria-checked="selected==filter.val" :id="filter.val" :checked="selected==filter.val" :value="filter.val" /> <label :for="filter.val" :class="{disabled: disabled}" >{{filter.name}}</label> </div> </div>');
